/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_video_api_verification_upload_post } from '../models/Body_upload_video_api_verification_upload_post';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VerificationService {
    /**
     * Upload Video
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public static uploadVideoApiVerificationUploadPost(
        formData: Body_upload_video_api_verification_upload_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/verification/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Uploaded Skip
     * @returns any Successful Response
     * @throws ApiError
     */
    public static uploadedSkipApiVerificationUploadedSkipPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/verification/uploaded-skip',
        });
    }
}
